/**
 * domaine — ce que l'adresse du site implique sur la langue.
 *
 * L'application est servie sous deux enseignes qui ne s'adressent pas au même
 * public :
 *
 *   1cours1bot.fr    le site français. Une seule langue, pas de sélecteur.
 *   1course1bot.com  le site international. Le sélecteur y est offert.
 *
 * C'est le MÊME déploiement : même bundle, même API, même base. Seules la
 * langue de départ et la présence du sélecteur changent, et elles se décident
 * ici. Rien dans nginx ne saurait le faire : masquer un composant React est une
 * affaire de front, le serveur ne voit qu'un fichier statique.
 *
 * ── Ce que le domaine remplace, et ce qu'il ne remplace pas ──
 *
 * Le domaine se substitue à la DÉTECTION NAVIGATEUR, pas aux choix explicites.
 * `?lang=` et la préférence enregistrée sur le compte continuent de l'emporter,
 * ici comme partout ailleurs (cf. `detection.js`). Un domaine reste une
 * supposition sur qui arrive, exactement comme `navigator.languages` ; il est
 * seulement mieux informé.
 *
 * ── Pourquoi le .fr FORCE le français au lieu de seulement cacher le sélecteur ──
 *
 * Parce que cacher seul serait un piège. Sans cette règle, un visiteur dont le
 * navigateur est réglé en allemand verrait le site français en allemand, et on
 * lui aurait retiré le seul contrôle qui lui permettait d'en sortir. Cacher le
 * choix oblige à ne plus avoir besoin de choisir.
 *
 * ── Tout ce qui n'est pas le .fr est multilingue ──
 *
 * La liste énumère les domaines MONOLINGUES, jamais les multilingues. C'est
 * délibéré : `localhost` et `edubot.local` tombent ainsi du côté du sélecteur,
 * et le développement peut éprouver les cinq langues sans réglage particulier.
 * Un domaine ajouté demain est multilingue par défaut, ce qui est le sens de
 * l'histoire — l'exception est le site français, pas l'inverse.
 */

/** Les adresses qui ne servent que le français. `www.` compris : nginx le redirige, pas le front. */
export const DOMAINES_MONOLINGUES = Object.freeze([
    '1cours1bot.fr',
    'www.1cours1bot.fr',
]);

/** L'hôte courant, en minuscules. Isolé pour que les tests puissent en injecter un. */
const hoteCourant = () => {
    try {
        return String(window.location.hostname || '').toLowerCase();
    } catch (e) {
        // Rendu hors navigateur : on se comporte comme le site international,
        // c'est-à-dire sans rien retirer.
        return '';
    }
};

/**
 * Ce domaine ne sert-il que le français ?
 *
 * @param {string} [hote] - à ne passer que depuis les tests.
 */
export const siteMonolingue = (hote = hoteCourant()) =>
    DOMAINES_MONOLINGUES.includes(String(hote || '').toLowerCase());

/**
 * Ce domaine offre-t-il le choix de la langue ?
 *
 * C'est la fonction que lisent le sélecteur et la page d'accueil : on demande
 * « ai-je le droit d'afficher ce contrôle », pas « suis-je sur telle adresse ».
 *
 * @param {string} [hote] - à ne passer que depuis les tests.
 */
export const siteMultilingue = (hote = hoteCourant()) => !siteMonolingue(hote);
